import { useMemo } from 'react';
import { useOrgConfigStateValue } from '../useOrgConfig';

export const useTikTokUSEnable = () => {
  const { whiteListConfig } = useOrgConfigStateValue();

  const enable = useMemo(
    () => whiteListConfig?.TIKTOK_US_ENABLE ?? false,
    [whiteListConfig?.TIKTOK_US_ENABLE],
  );

  return enable;
};
